import {APIv1} from '../api';

async function getUserData(props) {
    const {username, token} = props;

    try {
        const response = await APIv1.get(`/user/me/${username}/`, {
            headers: {
                Authorization: `Token ${token}`,
            }
        });

        return response.data
    } catch
        (err) {
        console.error('Something went wrong:', err);
        throw err;
    }
}

export default getUserData;

export async function updateUserPassword({password, token}) {
    // Get the user object from localStorage
    const items = JSON.parse(localStorage.getItem('user'));

    // Log the password to ensure it's being passed correctly
    console.log("Password being sent:", password);

    // Send the POST request to update the password
    const response = await APIv1.post(
        '/user/update/password/',
        {password}, // Password should be passed as an object { password: password }
        {
            headers: {
                Authorization: `Token ${token || items.token}`, // Use the passed token or fallback to token from localStorage
                'Content-Type': 'application/json',   // Ensure correct content type is set
            },
        }
    );

    // Check if the status is 200 or 201 for success
    return response.status === 201 || response.status === 200;
}
